import * as THREE from 'three';
import { elementBox } from '@/render/batch';
import { useSelectionStore } from '@/state/selection';
import { resetLayers, type StationImpl } from '../types';
import { ProjectsPanel } from './Panel';
import { ProjectsScene } from './Scene';

export const projects: StationImpl = {
  pick: 'none',
  enter({ layers, height }) {
    resetLayers(layers, height);
    // World-space footprint (the hero group is rotated), from the shell layers' elements.
    const box = new THREE.Box3();
    const el = new THREE.Box3();
    for (const h of layers.values()) {
      if (h.model.discipline !== 'arch' && h.model.discipline !== 'structure') continue;
      for (const entry of h.rig.elements.values()) box.union(elementBox(entry, el));
    }
    if (!box.isEmpty())
      useSelectionStore
        .getState()
        .setHeroSize([box.max.x - box.min.x, box.max.y - box.min.y, box.max.z - box.min.z]);
  },
  update() {},
  leave({ layers, height }) {
    resetLayers(layers, height);
  },
  Panel: ProjectsPanel,
  Scene: ProjectsScene,
};
